import { FlexBox } from '@helloself/hello-self-ui';
import styled from 'styled-components';

export const DashedBorderFlexBox = styled(FlexBox as any)`
    overflow: hidden;
    position: relative;

    text-align: center;
    &::before {
        content: '';
        position: absolute;
        border: 5px dashed #c0c0c0;
        top: -4px;
        bottom: -4px;
        left: -4px;
        right: -4px;
    }
`;
